import { ComponentSize, SemanticColor, StatusColor, TagColor, TextColor } from '../../../types';
import { BadgeColor } from './Badge.types';

// Maps badge size to DaisyUI classes.
export const BADGE_SIZE: Record<ComponentSize, string> = {
  [ComponentSize.X_SMALL]: 'badge-xs',
  [ComponentSize.SMALL]: 'badge-sm',
  [ComponentSize.MEDIUM]: 'badge-md',
  [ComponentSize.LARGE]: 'badge-lg',
};

export const BADGE_ICON_SIZE: Record<ComponentSize, ComponentSize> = {
  [ComponentSize.X_SMALL]: ComponentSize.X_SMALL,
  [ComponentSize.SMALL]: ComponentSize.X_SMALL,
  [ComponentSize.MEDIUM]: ComponentSize.SMALL,
  [ComponentSize.LARGE]: ComponentSize.SMALL,
};

export const DEFAULT_BADGE_CLASSES = {
  bgColor: 'badge-ghost',
  hoverBgColor: 'bg-base-content/10',
  textColor: TextColor.PRIMARY,
};

export const OUTLINE_BADGE_CLASSES = {
  bgColor: 'badge-outline',
  hoverBgColor: 'bg-base-content/10',
  textColor: TextColor.SECONDARY,
};

export const BADGE_COLOR_TO_CLASSES: Record<BadgeColor, { bgColor: string; textColor: string; hoverBgColor: string }> =
  {
    [SemanticColor.ACCENT]: {
      bgColor: 'bg-accent-content',
      hoverBgColor: 'bg-accent/20',
      textColor: 'text-accent',
    },
    [StatusColor.ERROR]: {
      bgColor: 'bg-error-content',
      hoverBgColor: 'bg-error/20',
      textColor: 'text-error',
    },
    [StatusColor.SUCCESS]: {
      bgColor: 'bg-success-content',
      hoverBgColor: 'bg-success/20',
      textColor: 'text-success',
    },
    [StatusColor.INFO]: {
      bgColor: 'bg-secondary-content',
      hoverBgColor: 'bg-secondary/20',
      textColor: 'text-secondary',
    },
    [TagColor.RED]: {
      bgColor: 'bg-tags-red-content',
      hoverBgColor: 'bg-tags-red/20',
      textColor: 'text-tags-red',
    },
    [TagColor.PINK]: {
      bgColor: 'bg-tags-pink-content',
      hoverBgColor: 'bg-tags-pink/20',
      textColor: 'text-tags-pink',
    },
    [TagColor.PURPLE]: {
      bgColor: 'bg-tags-purple-content',
      hoverBgColor: 'bg-tags-purple/20',
      textColor: 'text-tags-purple',
    },
    [TagColor.INDIGO]: {
      bgColor: 'bg-tags-indigo-content',
      hoverBgColor: 'bg-tags-indigo/20',
      textColor: 'text-tags-indigo',
    },
    [TagColor.LIGHT_BLUE]: {
      bgColor: 'bg-tags-light-blue-content',
      hoverBgColor: 'bg-tags-light-blue/20',
      textColor: 'text-tags-light-blue',
    },
    [TagColor.TEAL]: {
      bgColor: 'bg-tags-teal-content',
      hoverBgColor: 'bg-tags-teal/20',
      textColor: 'text-tags-teal',
    },
    [TagColor.LIME]: {
      bgColor: 'bg-tags-lime-content',
      hoverBgColor: 'bg-tags-lime/20',
      textColor: 'text-tags-lime',
    },
    [TagColor.YELLOW]: {
      bgColor: 'bg-tags-yellow-content',
      hoverBgColor: 'bg-tags-yellow/20',
      textColor: 'text-tags-yellow',
    },
    [TagColor.ORANGE]: {
      bgColor: 'bg-tags-orange-content',
      hoverBgColor: 'bg-tags-orange/20',
      textColor: 'text-tags-orange',
    },
  };
